import * as React from "react"
export const RequestedIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} {...props}>
    <path
      fill="#fff"
      d="M8 16a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8Zm1.441-4.993 2.4-2.6a.6.6 0 0 0 0-.814l-2.4-2.6a.6.6 0 1 0-.882.814L10.03 7.4H4.6a.6.6 0 1 0 0 1.2h5.43l-1.471 1.593a.6.6 0 0 0 .882.814Z"
    />
  </svg>
)
